"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectNoneRoleComment = exports.projectRoleAccessRights = exports.projectScopes = void 0;
exports.hasProjectAccessByRole = hasProjectAccessByRole;
exports.projectScopes = [
    "projectMembers:read",
    "projectMembers:CUD",
    "apiKeys:read",
    "apiKeys:CUD",
    "objects:publish",
    "objects:bookmark",
    "objects:tag",
    "traces:delete",
    "scores:CUD",
    "scoreConfigs:CUD",
    "scoreConfigs:read",
    "annotationQueues:read",
    "annotationQueues:CUD",
    "annotationQueueAssignments:read",
    "annotationQueueAssignments:CUD",
    "project:read",
    "project:update",
    "project:delete",
    "integrations:CRUD",
    "datasets:read",
    "datasets:CUD",
    "prompts:CUD",
    "prompts:read",
    "promptProtectedLabels:CUD",
    "dashboards:read",
    "dashboards:CUD",
    "models:CUD",
    "batchExports:create",
    "batchExports:read",
    "evaluator:CUD",
    "evaluator:read",
    "evaluationRule:read",
    "evaluationRule:CUD",
    "evalJobExecution:read",
    "evalDefaultModel:read",
    "evalDefaultModel:CUD",
    "llmApiKeys:read",
    "llmApiKeys:create",
    "llmApiKeys:update",
    "llmApiKeys:delete",
    "llmSchemas:CUD",
    "llmSchemas:read",
    "llmTools:CUD",
    "llmTools:read",
    "playground:execute",
    "comments:CUD",
    "comments:read",
    "promptExperiments:CUD",
    "promptExperiments:read",
    "projectAuditLogs:read",
    "TableViewPresets:CUD",
    "TableViewPresets:read",
    "automations:CUD",
    "automations:read",
    "alerts:read",
    "alerts:CUD",
    // Public-API action tokens; not granted to any UI role.
    "traces:read",
    "traces:create",
    "scores:read",
    "scores:create",
    "media:read",
    "media:create",
    "sessions:read",
    "metrics:read",
    "models:read",
    "experiments:read",
    "feedback:create",
];
exports.projectRoleAccessRights = {
    OWNER: [
        "project:read",
        "project:update",
        "project:delete",
        "projectMembers:read",
        "projectMembers:CUD",
        "apiKeys:read",
        "apiKeys:CUD",
        "integrations:CRUD",
        "objects:publish",
        "objects:bookmark",
        "objects:tag",
        "traces:delete",
        "scores:CUD",
        "scoreConfigs:CUD",
        "scoreConfigs:read",
        "datasets:read",
        "datasets:CUD",
        "prompts:CUD",
        "prompts:read",
        "promptProtectedLabels:CUD",
        "models:CUD",
        "evaluator:CUD",
        "evaluator:read",
        "evaluationRule:CUD",
        "evaluationRule:read",
        "evalJobExecution:read",
        "evalDefaultModel:CUD",
        "evalDefaultModel:read",
        "llmApiKeys:read",
        "llmApiKeys:create",
        "llmApiKeys:update",
        "llmApiKeys:delete",
        "llmSchemas:CUD",
        "llmSchemas:read",
        "llmTools:CUD",
        "llmTools:read",
        "playground:execute",
        "batchExports:create",
        "batchExports:read",
        "comments:CUD",
        "comments:read",
        "annotationQueues:read",
        "annotationQueues:CUD",
        "annotationQueueAssignments:read",
        "annotationQueueAssignments:CUD",
        "promptExperiments:CUD",
        "promptExperiments:read",
        "projectAuditLogs:read",
        "dashboards:read",
        "dashboards:CUD",
        "TableViewPresets:CUD",
        "TableViewPresets:read",
        "automations:CUD",
        "automations:read",
        "alerts:read",
        "alerts:CUD",
    ],
    ADMIN: [
        "project:read",
        "project:update",
        "projectMembers:read",
        "projectMembers:CUD",
        "apiKeys:read",
        "apiKeys:CUD",
        "integrations:CRUD",
        "objects:publish",
        "objects:bookmark",
        "objects:tag",
        "traces:delete",
        "scores:CUD",
        "scoreConfigs:CUD",
        "scoreConfigs:read",
        "datasets:read",
        "datasets:CUD",
        "prompts:CUD",
        "prompts:read",
        "promptProtectedLabels:CUD",
        "models:CUD",
        "evaluator:CUD",
        "evaluator:read",
        "evaluationRule:CUD",
        "evaluationRule:read",
        "evalJobExecution:read",
        "evalDefaultModel:CUD",
        "evalDefaultModel:read",
        "llmApiKeys:read",
        "llmApiKeys:create",
        "llmApiKeys:update",
        "llmApiKeys:delete",
        "llmSchemas:CUD",
        "llmSchemas:read",
        "llmTools:CUD",
        "llmTools:read",
        "playground:execute",
        "batchExports:create",
        "batchExports:read",
        "comments:CUD",
        "comments:read",
        "annotationQueues:read",
        "annotationQueues:CUD",
        "annotationQueueAssignments:read",
        "annotationQueueAssignments:CUD",
        "promptExperiments:CUD",
        "promptExperiments:read",
        "projectAuditLogs:read",
        "dashboards:read",
        "dashboards:CUD",
        "TableViewPresets:CUD",
        "TableViewPresets:read",
        "automations:CUD",
        "automations:read",
        "alerts:read",
        "alerts:CUD",
    ],
    MEMBER: [
        "project:read",
        "projectMembers:read",
        "apiKeys:read",
        "objects:publish",
        "objects:bookmark",
        "objects:tag",
        "scores:CUD",
        "scoreConfigs:CUD",
        "scoreConfigs:read",
        "datasets:read",
        "datasets:CUD",
        "prompts:CUD",
        "prompts:read",
        "evaluator:CUD",
        "evaluator:read",
        "evaluationRule:read",
        "evaluationRule:CUD",
        "evalJobExecution:read",
        "evalDefaultModel:read",
        "evalDefaultModel:CUD",
        "llmApiKeys:read",
        "llmSchemas:read",
        "llmSchemas:CUD",
        "llmTools:CUD",
        "llmTools:read",
        "playground:execute",
        "batchExports:create",
        "batchExports:read",
        "comments:CUD",
        "comments:read",
        "annotationQueues:read",
        "annotationQueues:CUD",
        "annotationQueueAssignments:read",
        "promptExperiments:CUD",
        "promptExperiments:read",
        "dashboards:read",
        "dashboards:CUD",
        "TableViewPresets:CUD",
        "TableViewPresets:read",
        "automations:read",
        "alerts:read",
        "alerts:CUD",
    ],
    VIEWER: [
        "project:read",
        "prompts:read",
        "evaluator:read",
        "scoreConfigs:read",
        "evaluationRule:read",
        "evalJobExecution:read",
        "evalDefaultModel:read",
        "datasets:read",
        "llmApiKeys:read",
        "llmSchemas:read",
        "llmTools:read",
        "comments:read",
        "annotationQueues:read",
        "promptExperiments:read",
        "dashboards:read",
        "TableViewPresets:read",
        "automations:read",
        "alerts:read",
    ],
    NONE: [],
};
exports.projectNoneRoleComment = "Do not override the organization role for this project.";
/**
 * Pure role-based access check (no session), for callers that already
 * resolved the caller's project role — e.g. the in-app agent runtime.
 * Mirrors the role branch of web's `hasProjectAccess`.
 */
function hasProjectAccessByRole(p) {
    if (p.admin)
        return true;
    return exports.projectRoleAccessRights[p.role].includes(p.scope);
}
